import { render, staticRenderFns } from "./Guide.vue?vue&type=template&id=5fb6b9b7&scoped=true"
import script from "./Guide.vue?vue&type=script&lang=ts"
export * from "./Guide.vue?vue&type=script&lang=ts"
import style0 from "./Guide.vue?vue&type=style&index=0&id=5fb6b9b7&prod&lang=sass&scoped=true"
import style1 from "./Guide.vue?vue&type=style&index=1&id=5fb6b9b7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6b9b7",
  null
  
)

export default component.exports